import { render } from "./InfoPills.vue?vue&type=template&id=d84fab4c&ts=true"
import script from "./InfoPills.vue?vue&type=script&lang=ts"
export * from "./InfoPills.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__